var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-nav'),_c('router-view'),(_vm.currentModal)?_c(_vm.currentModal.type,{tag:"component",attrs:{"options":_vm.currentModal.options},on:{"close":function($event){return _vm.$store.commit('clearCurrentModal')}}}):_vm._e(),_c('div',{staticClass:"preload-font"},[_vm._v(".")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }